var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 15",
    style: {
      enableBackground: "new 0 0 20 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000003102508794982528820000016579575389048855438_);fill:#003399;}\r\n\t.st1{clip-path:url(#SVGID_00000003102508794982528820000016579575389048855438_);fill:#FFCC00;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2,0h16c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017505779069845701190000000100772436355769015_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#003399"
    },
    width: 20,
    height: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "9.7,2.8  9.4,3.5 9.6,3.4 10,3 10.6,3.5 10.5,3.3 10.3,2.8 11,2.4 10.8,2.4 10.2,2.4 10,1.7 9.9,1.9 9.8,2.4 9,2.4 9.2,2.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "10.8,12.2  10.2,12.2 10,11.5 9.9,11.6 9.8,12.2 9,12.2 9.2,12.3 9.7,12.5 9.4,13.3 9.6,13.2 10,12.8 10.6,13.3 10.5,13.1 10.3,12.6 11,12.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "5.7,8.4  5.6,8.2 5.4,7.7 6.1,7.3 5.9,7.3 5.3,7.3 5.1,6.6 5.1,6.7 4.9,7.3 4.1,7.3 4.3,7.4 4.8,7.7 4.5,8.4 4.7,8.3 5.1,7.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "7.8,3.1  7.6,2.4 7.6,2.5 7.4,3.1 6.7,3.1 6.8,3.2 7.3,3.5 7,4.2 7.2,4.1 7.6,3.7 8.2,4.2 8.1,4 7.9,3.5 8.6,3.1 8.4,3.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "5.5,5.3  5.2,6 5.4,5.9 5.8,5.5 6.4,6 6.3,5.8 6.1,5.3 6.8,4.9 6.6,4.9 6,4.9 5.8,4.2 5.7,4.4 5.6,4.9 4.8,4.9 5,5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "6.1,10.2  6.8,9.8 6.6,9.8 6,9.8 5.8,9.1 5.7,9.3 5.6,9.8 4.8,9.8 5,9.9 5.5,10.2 5.2,10.9 5.4,10.8 5.8,10.4 6.4,10.9 6.3,10.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "8.3,11.4  7.8,11.5 7.6,10.7 7.5,10.9 7.4,11.4 6.6,11.4 6.8,11.5 7.2,11.8 7,12.6 7.1,12.4 7.5,12.1 8.2,12.6 8.1,12.4 7.9,11.9 8.5,11.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "15.2,7.7  15.9,7.3 15.7,7.3 15.1,7.3 14.9,6.6 14.8,6.7 14.7,7.3 13.9,7.3 14.1,7.4 14.6,7.7 14.3,8.4 14.4,8.3 14.9,7.9 15.5,8.4  15.4,8.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "12.1,3.5  11.8,4.2 11.9,4.1 12.4,3.7 13,4.2 12.9,4 12.7,3.5 13.3,3.1 13.2,3.1 12.6,3.1 12.4,2.4 12.3,2.5 12.2,3.1 11.4,3.1 11.6,3.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "13.4,5  13.9,5.3 13.6,6 13.8,5.9 14.2,5.5 14.8,6 14.7,5.8 14.5,5.3 15.2,4.9 15,4.9 14.4,4.9 14.2,4.2 14.1,4.4 14,4.9 13.2,4.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "15,9.8  14.4,9.8 14.2,9.1 14.1,9.3 14,9.8 13.2,9.8 13.4,9.9 13.9,10.2 13.6,10.9 13.8,10.8 14.2,10.4 14.8,10.9 14.7,10.7 14.5,10.2  15.2,9.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000017505779069845701190000000100772436355769015_)",
      fill: "#FFCC00"
    },
    points: "13.2,11.4  12.7,11.5 12.4,10.7 12.4,10.9 12.3,11.4 11.5,11.4 11.6,11.5 12.1,11.8 11.8,12.6 12,12.4 12.4,12.1 13,12.6 13,12.4 12.7,11.9  13.4,11.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.c4028aa987d4ff73a43ad1d4d8918342.svg";
export { ForwardRef as ReactComponent };